import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'max',
  standalone: true
})
export class MaxPipe implements PipeTransform {
  transform(numbers: number[]): number {
    return Math.max(...numbers);
  }
}
